import { Trans, useTranslation } from 'react-i18next'

import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { marginInsightCopies } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/YourEarningsCard/constants'
import { getMarginInsightValues } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/YourEarningsCard/helpers'

import * as Styles from './styles'

const MarginInsight = ({ marginCosts }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  return (
    <Styles.Container>
      <MagnifyingGlassIcon size={20} color={theme.colors.text.default} />
      <Styles.Content>
        <Text type="titleS">{t('A dónde va tu margen')}</Text>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          <Trans
            i18nKey={marginInsightCopies[marginCosts.length]}
            values={getMarginInsightValues(marginCosts, t, i18n.language)}
            components={{ bold: <strong /> }}
          />
        </Text>
      </Styles.Content>
    </Styles.Container>
  )
}

export default MarginInsight
